<script lang="ts" setup>
import CartWidget from '~/components/cart/CartWidget.vue'
import BasicButton from '~/components/form-elements/BasicButton.vue'
import MindboxRecommendationsSection from '~/components/sections/MindboxRecommendationsSection.vue'
import { MindboxOperation } from '~/enums/mindbox-operation'
import Page from '~/enums/page'
import ProductSort from '~/enums/product-sort'
</script>

<template>
  <div>
    <section>
      <div class="container">
        <div class="flex w-full flex-col items-center rounded-xl bg-white p-6">
          <div class="mb-10 flex flex-col items-center sm:my-[50px]">
            <SvgIcon class="!size-[44px]" name="outlined/big-cart" />

            <h1 class="!mb-0 mt-5 text-lg font-medium leading-[122%] sm:text-[36px]">
              Вы ничего не&nbsp;добавили
            </h1>

            <p
              class="
                mt-2 max-w-[280px] text-center text-xs font-normal leading-[140%] text-[#434242] opacity-[.4]
                sm:text-base
              "
            >
              Перейдите в&nbsp;каталог, чтобы найти все, что&nbsp;вам&nbsp;нужно
            </p>

            <BasicButton
              class="m-auto mt-4 !h-[56px] !w-full sm:mt-5 sm:!w-[196px]"
              color="green"
              title="Начать покупки"
              @click="navigateTo(Page.Search)"
            />
          </div>
        </div>

        <div v-if="false" class="mt-4 flex justify-center">
          <CartWidget class="w-full bg-white md:max-w-[391px]">
            <strong class="block text-[13px] font-medium text-[#434242]">
              Подарим сертификат на&nbsp;3000&nbsp;₽&nbsp;на&nbsp;день отдыха в&nbsp;санатории за&nbsp;первый заказ&nbsp;от&nbsp;3000&nbsp;₽!
            </strong>

            <a
              class="mt-2 block text-[13px] leading-tight text-main-green"
              href="https://itab.pro/special-offers/podarok-za-registratsiyu-i-pervyy-zakaz-ot-3000-rub-den-v-sanatorii-11/"
            >Подробнее</a>
          </CartWidget>
        </div>
      </div>
    </section>

    <MindboxRecommendationsSection
      class="mt-10"
      :data="{ recommendation: { limit: 12 } }"
      :operation="MindboxOperation.PersonalRecommendations"
      title="Специально для вас"
    />

    <MindboxRecommendationsSection
      class="mt-10"
      :data="{ recommendation: { limit: 12 } }"
      :operation="MindboxOperation.PopularProducts"
      :path="Page.Search"
      :query-parameters="{ sort: ProductSort.MostPopular }"
      title="Популярное"
    />
  </div>
</template>
